//noinspection DuplicatedCode,JSUnresolvedVariable,SpellCheckingInspection,JSUnresolvedFunction

import React, {Component} from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import appTheme from "../../../assets/appTheme";
import './DLToast.css'


class DLToastMessageView extends Component {

  componentDidUpdate(prevProps, prevState, snapshot) {

    if (this.props.systemError.isVisible) {
      if (!prevProps.systemError.reloadApp && this.props.systemError.reloadApp) {
        setTimeout(() => {
          document.location.reload();
        }, 150);
      }
    }
  }


  reloadApp() {
    window.location.reload();
  }


  render() {
    const {closeToastAction, hideSystemErrorBlock, systemError} = this.props;
    const {type, isVisible, message, timeout} = this.props.toastStatus;

    let messageUI = null;
    switch (type) {
      case 'success':
        messageUI = <Alert style={{color: '#FFF'}} severity="success" variant="filled">{message}</Alert>;
        break;
      case 'danger':
        messageUI = <Alert style={{color: '#FFF'}} severity="error" variant="filled">{message}</Alert>;
        break;
      case 'info':
        messageUI = <Alert style={{color: '#FFF'}} severity="info" variant="filled">{message}</Alert>;
        break;
      case 'warning':
        messageUI = <Alert style={{color: '#FFF'}} severity="warning" variant="filled">{message}</Alert>;
        break;
      default:
        break;
    }

    return (

      <>

        <Snackbar
          anchorOrigin={{vertical: 'top', horizontal: 'center'}}
          open={isVisible}
          onClose={closeToastAction}
          autoHideDuration={timeout}>
          {messageUI}
        </Snackbar>

        <div className='dl-toast'>
          <Snackbar
            open={systemError.isVisible}
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            autoHideDuration={100}>
            <div
              className="dl-toast rounded-1 d-flex justify-content-center align-items-center"
              style={{
                background: appTheme.appColor.danger,
                color: '#FFF',
                padding: '12px 10px'
              }}>
              <i className="fa-solid fa-triangle-exclamation mx-2" />
              <div className="mx-2">
                {navigator.onLine
                  ?
                  <span>Something went wrong. Please try again or contact us</span>
                  :
                  <span>No Internet Connection</span>
                }
              </div>
              <i className="fa-solid fa-rotate-right mx-2 cursor"
                 onClick={() => this.reloadApp()}
              />
              <i className="fa-solid fa-xmark mx-2 cursor"
                 onClick={hideSystemErrorBlock}
              />
            </div>
          </Snackbar>
        </div>

      </>
    );
  }

}

export default DLToastMessageView;
